import { Form, Table } from "react-bootstrap";
import { useIntl } from "react-intl";
import { NetlinkingOrderInfoFrom } from "src/app/components";
import { IStepsList } from "src/app/components/form/FormikStepper";
import { SimpleFormSelect, SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { SimpleFormTextarea } from "src/app/components/form/SimpleFormTextarea";
import Pacman from "src/app/components/layout/Pacman";
import {
    UpsertNetlinkingBoostKeywordsSchema,
    UpsertNetlinkingBoostUserKeywordsSchema,
} from "src/app/types/NetlinkigBoost";
import { INetlinkingOrderInfo } from "src/app/types/orders/order";
import { ISemRushKeywords } from "src/app/types/semrush";

export const NetlinkingStepsList = (
    selectedKeywords: string[],
    handleSelectedKeyword: (keywords: string) => void,
    keywords: ISemRushKeywords[],
    loading: boolean,
    frequencyOptions: SimpleFormSelectOption[],
    url?: string | null,
    netlinkingOrderInfo?: INetlinkingOrderInfo[],
    error?: string
): IStepsList[] => {
    const { formatMessage } = useIntl();
    const price = Number(process.env.REACT_APP_KEYWORDS_AUTO_AI_PRICE || 0);

    return [
        {
            title: `${formatMessage({ id: "common.stepper.semRushKeywords" })}`,
            api: "semRushKeywords",
            element: (
                <>
                    {!loading ? (
                        <>
                            {error ? (
                                <>{error}</>
                            ) : (
                                <div className="netlinkingWrapper">
                                    <div className="formSelectWrapper">
                                        <div className="d-flex justify-content-between w-100 pe-3">
                                            <div className="d-flex align-content-center align-items-center">
                                                <Form.Label>
                                                    {formatMessage({
                                                        id: "common.field.frequency",
                                                    })}
                                                    :
                                                </Form.Label>
                                                <SimpleFormSelect
                                                    isClearable={false}
                                                    name="frequency"
                                                    values={frequencyOptions}
                                                />
                                            </div>
                                            <div className="d-flex justify-content-end mt-2 p-2 bg-light rounded">
                                                <div className="selected-keywords-counter">
                                                    <strong>
                                                        {formatMessage(
                                                            { id: "common.text.totalKeywords" },
                                                            { count: selectedKeywords.length }
                                                        )}{" "}
                                                        ({selectedKeywords.length}/{keywords.length}
                                                        )
                                                    </strong>
                                                    <span className="badge bg-primary ms-2">
                                                        {selectedKeywords.length}
                                                    </span>
                                                    <div className="d-flex flex-column text-end">
                                                        <strong>
                                                            {formatMessage({
                                                                id: "common.text.totalprice",
                                                            })}
                                                            :{" "}
                                                            {new Intl.NumberFormat("de-DE", {
                                                                style: "currency",
                                                                currency: "EUR",
                                                            }).format(
                                                                selectedKeywords.length * price
                                                            )}
                                                        </strong>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="netlinkingWrapperTable">
                                        <Table bordered>
                                            <thead>
                                                <tr
                                                    className={"header-no-Selected"}
                                                    onClick={() =>
                                                        handleSelectedKeyword(
                                                            selectedKeywords.length ===
                                                                keywords.length
                                                                ? "REMOVE_KEYWORDS"
                                                                : "ALL_KEYWORDS"
                                                        )
                                                    }
                                                >
                                                    <th>
                                                        <Form.Check
                                                            type="switch"
                                                            checked={
                                                                selectedKeywords.length ===
                                                                keywords.length
                                                            }
                                                        />
                                                    </th>
                                                    <th>
                                                        {formatMessage({
                                                            id: "common.field.keywords",
                                                        })}
                                                    </th>
                                                    <th>
                                                        {formatMessage({
                                                            id: "common.field.volume",
                                                        })}
                                                    </th>
                                                    <th>
                                                        {formatMessage({
                                                            id: "common.field.price",
                                                        })}
                                                    </th>
                                                    <th>
                                                        {formatMessage({
                                                            id: "common.field.keywordDifficultyIndex",
                                                        })}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {keywords?.map((keywordsData, index) => (
                                                    <tr
                                                        key={index}
                                                        onClick={() =>
                                                            handleSelectedKeyword(
                                                                keywordsData.keyword || ""
                                                            )
                                                        }
                                                        className={
                                                            selectedKeywords.includes(
                                                                keywordsData.keyword || ""
                                                            )
                                                                ? "selected"
                                                                : ""
                                                        }
                                                    >
                                                        <td>
                                                            <Form.Check
                                                                type="switch"
                                                                checked={selectedKeywords.includes(
                                                                    keywordsData.keyword || ""
                                                                )}
                                                                onChange={() => {}}
                                                            />
                                                        </td>
                                                        <td>{keywordsData.keyword}</td>
                                                        <td>{keywordsData.volume}</td>
                                                        <td>
                                                            {new Intl.NumberFormat("de-DE", {
                                                                style: "currency",
                                                                currency: "EUR",
                                                            }).format(price)}
                                                        </td>
                                                        <td>
                                                            {keywordsData.keywordDifficultyIndex}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>{" "}
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        <Pacman />
                    )}
                </>
            ),
            validationSchema: UpsertNetlinkingBoostKeywordsSchema,
        },
        {
            title: `${formatMessage({ id: "common.stepper.userKeywords" })}`,
            api: "userKeywords",
            element: (
                <>
                    <div className="d-flex justify-content-end mt-2 p-2 bg-light rounded">
                        <div className="selected-keywords-counter">
                            <span className="badge bg-primary me-2">{selectedKeywords.length}</span>
                            <strong>
                                {formatMessage(
                                    { id: "common.text.totalKeywords" },
                                    { count: selectedKeywords.length }
                                )}{" "}
                                ({selectedKeywords.length}/{keywords.length})
                            </strong>
                            <div className="d-flex flex-column text-end">
                                <strong>
                                    {formatMessage({
                                        id: "common.text.totalprice",
                                    })}
                                    :{" "}
                                    {new Intl.NumberFormat("de-DE", {
                                        style: "currency",
                                        currency: "EUR",
                                    }).format(selectedKeywords.length * price)}
                                </strong>
                            </div>
                        </div>
                    </div>
                    <SimpleFormTextarea
                        name="userKeywords"
                        rows={20}
                        label={formatMessage({ id: "common.field.userKeywords" })}
                    />
                </>
            ),
            validationSchema: UpsertNetlinkingBoostUserKeywordsSchema,
        },
        {
            title: `${formatMessage({ id: "common.stepper.orderInfo" })}`,
            api: "orderInfo",
            element: (
                <NetlinkingOrderInfoFrom
                    netlinkingOrderInfo={netlinkingOrderInfo}
                    loading={loading}
                    url={url}
                />
            ),
            validationSchema: UpsertNetlinkingBoostKeywordsSchema,
        },
    ];
};
